import { getSharedAudioContext, unlockAudioContext } from "./playAudio";

let mixDestination = null;
let micSource = null;
const wiredElements = new WeakSet();
let playPatchInstalled = false;
let nativePlay = null;

function wireMediaElement(audioEl) {
  const ctx = getSharedAudioContext();
  if (!ctx || !mixDestination || !audioEl || wiredElements.has(audioEl)) return;

  try {
    const source = ctx.createMediaElementSource(audioEl);
    source.connect(ctx.destination);
    source.connect(mixDestination);
    wiredElements.add(audioEl);
  } catch (err) {
    console.warn("[composite-audio] élément non routé", err);
  }
}

function installPlayPatch() {
  if (playPatchInstalled) return;
  playPatchInstalled = true;
  nativePlay = HTMLMediaElement.prototype.play;
  HTMLMediaElement.prototype.play = function compositeMixPlay(...args) {
    if (mixDestination && this instanceof HTMLAudioElement) {
      wireMediaElement(this);
    }
    return nativePlay.apply(this, args);
  };
}

function uninstallPlayPatch() {
  if (!playPatchInstalled || !nativePlay) return;
  HTMLMediaElement.prototype.play = nativePlay;
  playPatchInstalled = false;
  nativePlay = null;
}

/** Branche micro + effets jeu dans un flux audio pour l'enregistrement composite. */
export async function startCompositeAudioMix(micStream, rootEl) {
  await unlockAudioContext();
  const ctx = getSharedAudioContext();
  if (!ctx) return null;

  if (ctx.state === "suspended") {
    await ctx.resume().catch(() => {});
  }

  mixDestination = ctx.createMediaStreamDestination();

  if (micStream?.getAudioTracks?.().length) {
    try {
      micSource = ctx.createMediaStreamSource(micStream);
      micSource.connect(mixDestination);
    } catch (err) {
      console.warn("[composite-audio] micro non routé", err);
    }
  }

  installPlayPatch();

  if (rootEl) {
    rootEl.querySelectorAll("audio").forEach((el) => wireMediaElement(el));
  }

  return mixDestination.stream;
}

export function isCompositeAudioMixActive() {
  return mixDestination != null;
}

/** Branche une piste effet jeu dans le mix vidéo (voir playAudio.routeGameSample). */
export function connectGameSampleToMix(gainNode) {
  if (!mixDestination || !gainNode) return;
  try {
    gainNode.connect(mixDestination);
  } catch {
    /* ignore */
  }
}

export function stopCompositeAudioMix() {
  if (micSource) {
    try {
      micSource.disconnect();
    } catch {
      /* ignore */
    }
    micSource = null;
  }
  mixDestination = null;
  uninstallPlayPatch();
}
